import { render, staticRenderFns } from "./standardResults.vue?vue&type=template&id=57bd0c24&scoped=true&"
import script from "./standardResults.vue?vue&type=script&lang=js&"
export * from "./standardResults.vue?vue&type=script&lang=js&"
import style0 from "./standardResults.vue?vue&type=style&index=0&id=57bd0c24&scoped=true&lang=scss&"
import style1 from "./standardResults.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bd0c24",
  null
  
)

export default component.exports